import { Flex, Grid } from "@eworkit/iris";
import React from "react";
import { useTranslation } from "react-i18next";

import { EmptyText } from "@/components/EmptyText";
import { Group } from "@/components/Group";
import { ICompanyInsurance } from "@/data/companies";
import { Text } from "@/eworkitComponents";
import { AttachmentsList } from "@/views/components/Attachments";

interface ICompanyInsurancePreviewProps {
  insurance?: ICompanyInsurance;
}

export const CompanyInsurancePreview = ({ insurance }: ICompanyInsurancePreviewProps) => {
  const { t } = useTranslation("session");

  const getYesNoField = (field: keyof ICompanyInsurance) => (insurance?.[field] ? "Yes" : "No");

  return (
    <>
      <Flex mb="md">
        <Group
          direction="column"
          sx={{ width: "300px", mb: "10px" }}
          label={t("USERS.SETTINGS.INSURANCE_DETAILS.FORM.HAS_INSURANCE")}>
          <Text size="md">{getYesNoField("hasInsurance")}</Text>
        </Group>
      </Flex>

      {insurance?.hasInsurance && (
        <>
          <Grid columns="1fr 1fr" mb="lg">
            <Group
              direction="column"
              sx={{ width: "300px" }}
              label={t("USERS.SETTINGS.INSURANCE_DETAILS.FORM.EXPIRATION_DATE")}>
              <Text size="md">{insurance?.expirationDate ? insurance.expirationDate : <EmptyText />}</Text>
            </Group>

            <Group label={t("USERS.SETTINGS.INSURANCE_DETAILS.FORM.AMOUNT")} direction="column" sx={{ width: "300px" }}>
              <Text size="md">{insurance?.amount ? insurance.amount : <EmptyText />}</Text>
            </Group>
          </Grid>

          {insurance.file && <AttachmentsList attachments={[insurance.file]} />}
        </>
      )}
    </>
  );
};
